import { motion } from 'framer-motion';

export interface Tab {
  id: string;
  label: string;
}

interface TabNavigationProps {
  tabs: Tab[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
  className?: string;
}

export function TabNavigation({
  tabs,
  activeTab,
  onTabChange,
  className = '',
}: TabNavigationProps) {
  return (
    <div className={`flex gap-2 flex-wrap ${className}`}>
      {tabs.map(tab => (
        <button
          key={tab.id}
          onClick={() => onTabChange(tab.id)}
          className='relative px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300'
          style={{
            backgroundColor:
              activeTab === tab.id
                ? 'var(--clinic-primary)'
                : 'transparent',
            color:
              activeTab === tab.id
                ? 'white'
                : 'var(--clinic-text)',
            border: `1px solid ${
              activeTab === tab.id
                ? 'var(--clinic-primary)'
                : '#E5E7EB'
            }`,
          }}
        >
          {tab.label}
          {activeTab === tab.id && (
            <motion.div
              layoutId='activeTab'
              className='absolute inset-0 rounded-lg'
              style={{
                backgroundColor: 'var(--clinic-primary)',
                zIndex: -1,
              }}
              transition={{
                type: 'spring',
                stiffness: 380,
                damping: 30,
              }}
            />
          )}
        </button>
      ))}
    </div>
  );
}

